import keychainIcon from '../../assets/images/forgotPasswordFormKeychain.png'
import keychainIcon2x from '../../assets/images/forgotPasswordFormKeychain@2x.png'

export interface KeychainIconProps {
  size?: number
  className?: string
}

/**
 * Keychain Icon Component
 *
 * Displays the password reset keychain icon from Figma design.
 * Automatically uses @2x version for high-DPI displays.
 *
 * @example
 * <KeychainIcon size={100} />
 *
 * @example
 * <KeychainIcon size={64} className="my-custom-class" />
 */
export function KeychainIcon({ size = 100, className = '' }: KeychainIconProps) {
  return (
    <img
      src={keychainIcon}
      srcSet={`${keychainIcon} 1x, ${keychainIcon2x} 2x`}
      alt="Keychain"
      width={size}
      height={size}
      className={className}
    />
  )
}
